import { render } from "./PasswordList.vue?vue&type=template&id=8d7b1026&scoped=true&ts=true"
import script from "./PasswordList.vue?vue&type=script&lang=ts"
export * from "./PasswordList.vue?vue&type=script&lang=ts"

import "./PasswordList.vue?vue&type=style&index=0&id=8d7b1026&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7b1026"]])

export default __exports__